import React from 'react';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';

import { ParentSize } from '@visx/responsive';

import { IObjProps } from 'shared/consts/types';
import EmailAttachment from 'shared/icons/EmailAttachment';

const EmailHeader = ({
	userName,
	from,
	timestamp,
	isOpen = false,
	hasAttachments = false,
	colors,
}: {
	userName: string;
	from: string;
	timestamp: string;
	isOpen?: boolean;
	hasAttachments?: boolean;
	colors: IObjProps;
}) => {
	const [css, theme]: [any, any] = useStyletron();
	const { t } = useTranslation(['common']);

	return (
		<div
			className={css({
				height: '1.5rem',
				display: 'flex',
				alignItems: 'center',
			})}
		>
			<div
				className={css({
					flexGrow: 1,
				})}
			>
				<ParentSize>
					{({ width }) => (
						<div
							className={css({
								width: `${width - 4}px`,
								whiteSpace: 'noWrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							})}
						>
							<span
								className={css({
									paddingRight: '0.5rem',
									fontWeight: isOpen ? 400 : 700,
								})}
							>
								{userName}
							</span>
							{!isOpen && hasAttachments && <EmailAttachment fill={colors.icon} />}
							{isOpen && (
								<span
									className={css({
										color: colors.secondaryText,
									})}
								>{`<${from}>`}</span>
							)}
						</div>
					)}
				</ParentSize>
			</div>
			<div
				className={css({
					minWidth: 'fit-content',
					fontSize: '0.625rem',
					lineheight: '0.75rem',
				})}
			>
				{t('common:standardDateTimeFormatter', {
					date: timestamp,
				})}
			</div>
		</div>
	);
};

export default React.memo(EmailHeader);
